import React, { useState, useEffect } from 'react';
import { 
  SpeakerWaveIcon, 
  SpeakerXMarkIcon 
} from '@heroicons/react/24/outline';
import { voiceService } from '../../services/voiceService';

interface MessageAudioControlsProps {
  text: string;
  messageType: 'user' | 'assistant';
  buttonClassName?: string;
}

export const MessageAudioControls: React.FC<MessageAudioControlsProps> = ({
  text,
  messageType,
  buttonClassName,
}) => {
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [isSupported, setIsSupported] = useState(false);

  useEffect(() => {
    setIsSupported(voiceService.isVoiceSupported());
  }, []);

  useEffect(() => {
    // Verificar se está falando quando o componente monta
    setIsSpeaking(voiceService.isSpeaking());
  }, []);

  const handleSpeak = () => {
    if (isSpeaking) {
      voiceService.stopSpeaking();
      setIsSpeaking(false);
    } else {
      setIsSpeaking(true);
      voiceService.speak(
        text,
        () => setIsSpeaking(true),
        () => setIsSpeaking(false)
      );
    }
  };

  if (!isSupported)
  {
    return null;
  }

  const resolvedButtonClassName = buttonClassName
    ?? (messageType === 'user'
      ? 'text-blue-200 hover:text-white'
      : 'text-gray-400 hover:text-gray-600');

  return (
    <div className="flex items-center space-x-1">
      <button
        type="button"
        onClick={handleSpeak}
        className={`p-1 rounded transition-colors ${resolvedButtonClassName}`}
        title={isSpeaking ? 'Parar áudio' : 'Ouvir mensagem'}
        aria-label={isSpeaking ? 'Parar áudio' : 'Ouvir mensagem'}
      >
        {isSpeaking ? (
          <SpeakerXMarkIcon className="h-3 w-3" />
        ) : (
          <SpeakerWaveIcon className="h-3 w-3" />
        )}
      </button>
    </div>
  );
}; 